import {Alert} from "@mui/material";
import React from "react";

export const AlertMolecule = ({ options, message, close }: any) => (
    <div>
        <Alert
            variant="filled"
            severity={options.type === 'info' ? 'warning' : options.type}
        >
            {message}
        </Alert>
    </div>
);